/**
 * Get base display name from a user object (full name or fallbacks).
 * @param {Object} user - User object (may have fullName, firstName, lastName, email)
 * @returns {string}
 */
export function getUserDisplayName(user) {
  if (!user) return '';
  if (user.fullName) return user.fullName;
  const names = [user.firstName, user.lastName].filter(Boolean);
  return names.length > 0 ? names.join(' ').trim() : user.email || '';
}

/**
 * Get display string for user: "Full Name - Job Title".
 * Used in ToAndUfs / UserSearchInput dropdown and selected value.
 * @param {Object} user - User object (may have fullName, profile.jobTitle, etc.)
 * @returns {string}
 */
export function getUserDisplayWithJobTitle(user) {
  const fullName = getUserDisplayName(user);
  const jobTitle = user?.profile?.jobTitle;
  if (!fullName) return jobTitle || '';
  if (!jobTitle) return fullName;
  return `${fullName} - ${jobTitle}`;
}
